import { useSiteContent } from "@/context/SiteContentContext";

export const Logo = ({ variant = "light", size = "md" }) => {
  const { content } = useSiteContent();
  const brand = content.brand || { name: "ÖZKAYALAR", sub: "inşaat" };
  const sizeMap = {
    sm: { brand: "text-sm", sub: "text-xs" },
    md: { brand: "text-base", sub: "text-sm" },
    lg: { brand: "text-xl", sub: "text-lg" },
    xl: { brand: "text-3xl", sub: "text-2xl" },
  };
  const s = sizeMap[size] || sizeMap.md;
  return (
    <span className={`ozkayalar-logo ${variant}`} data-testid="brand-logo">
      <span className={`brand ${s.brand}`}>{brand.name}</span>
      <span className={`sub ${s.sub}`}>{brand.sub}</span>
    </span>
  );
};

export default Logo;
